import { Link } from "react-router-dom";
import React, { useState } from "react";
const VacaturesMenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("vacatures")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fas fa-user-check"></i> <span>Vacatures</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/vacatures" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-person"/> <span>Vacatures</span>
              </Link>
            </li>
            <li>
              <Link to="/vacatures/bedrijven" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-building" /> <span>Bedrijven</span>
              </Link>
            </li>
      
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default VacaturesMenu;
